
export default function Reasons() {
  const reasons = [
    {
      icon: 'ri-map-pin-user-line',
      title: '江田島市を中心に地域密着で対応',
      description: '地元に根ざしたサービスで、迅速かつ丁寧に対応いたします。',
    },
    {
      icon: 'ri-home-heart-line',
      title: '呉市出身（焼山町）',
      description: '地域のことをよく知る地元出身者が対応します。',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '1件ずつ丁寧な作業',
      description: 'お客様のご自宅を大切に、丁寧な作業を心がけています。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '写真・実績は許可をいただいたもののみ掲載',
      description: 'プライバシーを尊重し、許可をいただいた実績のみ公開しています。',
    },
  ];

  return (
    <section id="reasons" className="py-16 px-4 bg-gradient-to-b from-cyan-50 to-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          選ばれる理由
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-cyan-100 rounded-full mb-4">
                <i className={`${reason.icon} text-4xl text-cyan-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 text-left">{reason.title}</h3>
              <p className="text-base text-gray-700 font-normal leading-relaxed text-left">{reason.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
